<template>
  <div id="subpage">
    <el-col :span="24" class="warp-breadcrum">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>
          <b>平台数据</b>
        </el-breadcrumb-item>
        <el-breadcrumb-item>SAAS入住信息</el-breadcrumb-item>
      </el-breadcrumb>
    </el-col>
    <div class="content">
      <div
        v-loading="loading.loading"
        style="margin-top: -10px;margin-left: -10px;margin-right: -10px;"
      >
        <el-row>
          <el-col :span="24">
            <el-card>
              <div class="flex">
                <div class="gl-count">
                  <p>总代理商</p>
                  <p>
                    <count-to :startVal="0" :endVal="sum_manage" :duration="3000"></count-to>
                  </p>
                </div>
                <div class="gl-count">
                  <p>总用户</p>
                  <p>
                    <count-to :startVal="0" :endVal="sum_app" :duration="3000"></count-to>
                  </p>
                </div>
                <div class="gl-count">
                  <p>总流水</p>
                  <p>
                    ￥
                    <count-to :decimals="2" :startVal="0" :endVal="sum_ill" :duration="3000"></count-to>
                  </p>
                </div>
              </div>
            </el-card>
          </el-col>
        </el-row>

        <el-row class="mt10">
          <el-col :span="12" class="pr5">
            <el-card style="height: 280px">
              <el-col
                :span="24"
                class="flex center"
                style="border-bottom: 1px solid #eee;height: 120px"
              >
                <div class="text-center">
                  <p class="ft14">今日流水</p>
                  <p class="ft18 mt15">
                    ￥
                    <b class="ft24">{{ today_bill }}</b>
                    <span v-if="today_bill > yesterday_bill" class="zhang-color ml5">
                      <i class="iconfont icon-shangzhang ft24"></i>
                    </span>
                    <span v-if="today_bill < yesterday_bill" class="die-color ml5">
                      <i class="iconfont icon-xiadie ft24"></i>
                    </span>
                    <span v-if="today_bill == yesterday_bill" class="text-info ml5">-</span>
                  </p>
                  <p class="mt10 ft12 text-info">
                    昨日
                    {{ yesterday_bill }}
                  </p>
                </div>
              </el-col>

              <el-col :span="12" class="flex center mt20">
                <div class="text-center">
                  <p class="ft14">今日新增用户</p>
                  <p class="ft18 mt15">
                    <b class="ft24">{{ today_app }}</b>
                    <span v-if="today_app > yesterday_app" class="zhang-color ml5">
                      <i class="iconfont icon-shangzhang ft24"></i>
                    </span>
                    <span v-if="today_app < yesterday_app" class="die-color ml5">
                      <i class="iconfont icon-xiadie ft24"></i>
                    </span>
                    <span v-if="today_app == yesterday_app" class="text-info ml5">-</span>
                  </p>
                  <p class="mt10 ft12 text-info">
                    昨日
                    {{ yesterday_app }}
                  </p>
                </div>
              </el-col>
              <el-col :span="12" class="flex center mt20">
                <div class="text-center">
                  <p class="ft14">今日新增代理商</p>
                  <p class="ft18 mt15">
                    <b class="ft24">{{ today_manage }}</b>
                    <span v-if="today_manage > yesterday_manage" class="zhang-color ml5">
                      <i class="iconfont icon-shangzhang ft24"></i>
                    </span>
                    <span v-if="today_manage < yesterday_manage" class="die-color ml5">
                      <i class="iconfont icon-xiadie ft24"></i>
                    </span>
                    <span v-if="today_manage == yesterday_manage" class="text-info ml5">-</span>
                  </p>
                  <p class="mt10 ft12 text-info">
                    昨日
                    {{ yesterday_manage }}
                  </p>
                </div>
              </el-col>
            </el-card>
          </el-col>
          <el-col :span="12" class="pl5">
            <el-card style="height: 280px">
              <div class="flex space" style="position: relative;z-index: 1">
                <b>新增流水</b>
                <el-date-picker
                  :pickerOptions="pickerOptions"
                  @input="getDateBill"
                  v-model="billData"
                  size="mini"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                ></el-date-picker>
              </div>
              <ve-line
                v-loading="loading.billLoading"
                :colors="['red']"
                style="margin-top: -30px"
                height="300px"
                :legend-visible="false"
                :data="billData"
              ></ve-line>
            </el-card>
          </el-col>
        </el-row>
        <el-row class="mt10">
          <el-col :span="12" class="pr5">
            <el-card style="height: 280px">
              <div class="flex space" style="position: relative;z-index: 1">
                <b>新增用户</b>
                <el-date-picker
                  :pickerOptions="pickerOptions"
                  @input="getDateApp"
                  v-model="appDate"
                  size="mini"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                ></el-date-picker>
              </div>
              <ve-line
                v-loading="loading.appLoading"
                :colors="['deepskyblue']"
                style="margin-top: -30px"
                height="300px"
                :legend-visible="false"
                :data="appData"
              ></ve-line>
            </el-card>
          </el-col>
          <el-col :span="12" class="pl5">
            <el-card style="height: 280px">
              <div class="flex space" style="position: relative;z-index: 1">
                <b>新增代理商</b>
                <el-date-picker
                  :pickerOptions="pickerOptions"
                  @input="getDateManage"
                  v-model="manageDate"
                  size="mini"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                ></el-date-picker>
              </div>
              <ve-line
                v-loading="loading.manageLoading"
                style="margin-top: -30px"
                height="300px"
                :legend-visible="false"
                :data="manageData"
              ></ve-line>
            </el-card>
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>
<style>
.gl-count {
  flex: 1;
  text-align: center;
}

.gl-count p:nth-child(1) {
  font-size: 14px;
  line-height: 23px;
  margin-bottom: 16px;
  color: #666;
}

.gl-count p:nth-child(2) {
  font-size: 38px;
  line-height: 35px;
  color: #1676eb;
  font-weight: bold;
}

.gl-count p:nth-child(2):after {
  box-sizing: border-box;
}
</style>
<script>
import {
  getIndex,
  getDateApp,
  getDateBill,
  getDateManage,
} from "../../request/api/index";
import countTo from "vue-count-to";

export default {
  components: { countTo },
  data() {
    return {
      sum_ill: 0,
      sum_manage: 0,
      sum_app: 0,
      today_bill: 0,
      today_manage: 0,
      today_app: 0,
      yesterday_bill: 0,
      yesterday_manage: 0,
      yesterday_app: 0,
      billData: {
        columns: ["日期", "数量"],
        rows: [{ 日期: "1/1", 数量: 1393 }],
      },
      manageData: {
        columns: ["日期", "数量"],
        rows: [{ 日期: "1/1", 数量: 1393 }],
      },
      appData: {
        columns: ["日期", "数量"],
        rows: [{ 日期: "1/1", 数量: 1393 }],
      },
      manageDate: "",
      appDate: "",
      loading: {
        loading: true,
        billLoading: false,
        manageLoading: false,
        appLoading: false,
      },
      quota: {
        rest: 0,
        limit: 0,
      },
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
    };
  },
  created() {
    this.getIndex();
  },
  methods: {
    getIndex() {
      const that = this;
      that.axios.post("/index/index").then((res) => {
        console.log(res);
        if (res.code == 200) {
          this.sum_ill = res.data.sum_ill;
          this.sum_app = res.data.sum_app;
          this.sum_manage = res.data.sum_manage;
          this.today_bill = res.data.today_bill;
          this.today_manage = res.data.today_manage;
          this.today_app = res.data.today_app;
          this.yesterday_bill = res.data.yesterday_bill;
          this.yesterday_manage = res.data.yesterday_manage;
          this.yesterday_app = res.data.yesterday_app;
          this.loading.loading = false;
          //this.billDate = res.data.week_bill;
        } else {
          this.loading.loading = false;
          that.$message.error(res.msg);
        }
      });
    },
    getDateBill(e) {
      var Date1 = new Date();
      let day1 = e ? e[0] : new Date(Date1.getTime() - 144 * 60 * 60 * 1000);
      let day2 = e ? e[1] : Date1;
      let e_date =
        day1.getFullYear() + "-" + (day1.getMonth() + 1) + "-" + day1.getDate();
      let b_date =
        day2.getFullYear() + "-" + (day2.getMonth() + 1) + "-" + day2.getDate();
      this.loading.billLoading = true;
      getDateBill({
        e_date: e_date,
        b_date: b_date,
      })
        .then((res) => {
          this.billData.rows = res.bill;
          this.loading.billLoading = false;
        })
        .catch(() => {
          this.loading.billLoading = false;
        });
    },

    getDateApp(e) {
      var Date1 = new Date();
      let day1 = e ? e[0] : new Date(Date1.getTime() - 144 * 60 * 60 * 1000);
      let day2 = e ? e[1] : Date1;
      let e_date =
        day1.getFullYear() + "-" + (day1.getMonth() + 1) + "-" + day1.getDate();
      let b_date =
        day2.getFullYear() + "-" + (day2.getMonth() + 1) + "-" + day2.getDate();
      this.loading.appLoading = true;
      getDateApp({
        e_date: e_date,
        b_date: b_date,
      })
        .then((res) => {
          this.appData.rows = res.week_app;
          this.loading.appLoading = false;
        })
        .catch(() => {
          this.loading.appLoading = false;
        });
    },

    getDateManage(e) {
      var Date1 = new Date();
      let day1 = e ? e[0] : new Date(Date1.getTime() - 144 * 60 * 60 * 1000);
      let day2 = e ? e[1] : Date1;
      let e_date =
        day1.getFullYear() + "-" + (day1.getMonth() + 1) + "-" + day1.getDate();
      let b_date =
        day2.getFullYear() + "-" + (day2.getMonth() + 1) + "-" + day2.getDate();
      this.loading.manageLoading = true;
      getDateManage({
        e_date: e_date,
        b_date: b_date,
      })
        .then((res) => {
          this.manageData.rows = res.week_manage;
          this.loading.manageLoading = false;
        })
        .catch(() => {
          this.loading.manageLoading = false;
        });
    },
  },
};
</script>
